<div class="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 px-4">
    <div class="w-full max-w-2xl bg-white dark:bg-gray-800 shadow-lg rounded-2xl p-6">
  
      <!-- Logo no topo -->
      <div class="flex justify-center mb-6">
        <img
        [src]="
          this.darkMode ? '/images/logo_dark.png' : '/images/logo_light.png'
        "
        class="h-24"
        alt="eScout Logo"
      />
      </div>
  
      <!-- Formulário de cadastro -->
      <ui-dynamic-form (valueChange)="onSubmit($event)" [withBorder]="false" [useSteps]="false" [finalSubmit]="'Entrar'" [inList]="true" [fields]="currentFields"></ui-dynamic-form>
  
      <div class="text-center mt-4">
      <p class="text-sm text-gray-500 dark:text-gray-400 mt-4">
        Esqueceu sua senha?
        <a (click)="toResetPassword()" class="text-blue-500 hover:underline dark:text-blue-400 cursor-pointer">
          Clique aqui
        </a>
      </p>
    </div>
          <!-- Link para Login -->
          <div class="text-center mt-4">
            <p class="text-sm text-gray-500 dark:text-gray-400">
              Ainda não possui uma conta?
              <a (click)="toRegister()" class="text-blue-500 hover:underline dark:text-blue-400 cursor-pointer">
                Registre-se
              </a>
            </p>
          </div>
  
    </div>
  </div>
  